/** custom-gold 不覆盖业务文案，仅提供样式和图片 */
export default {};
